<template>
  <div>
    <div
      class="bill d-flex"
    >
      <!-- <div>
        <div
          class="product-set-icon"
          :class="result ? 'mt-4' : ''"
        >
          <i
            class="fa-solid"
            :class="catalogIcon(catalog.productCategory)"
          />
        </div>
      </div> -->
      <div class="flex-grow-1 align-self-center">
        <div
          v-if="result"
          class="mb-1"
        >
          <span
            v-if="result === 'Ordered'"
            class="badge badge-success"
          >
            Zamówiono
          </span>
          <div v-if="result === 'ReserveQueue'">
            <span
              class="badge badge-warning"
            >
              Lista rezerwowa
            </span>
            <span class="small ml-1">
              Pozycja: {{ reserveQueuePosition + 1 }}
            </span>
          </div>
          <span
            v-else-if="result === 'Rejected'"
            class="badge badge-danger"
          >
            Zamówienie nieudane
          </span>
        </div>
        <div
          class="bill-due-date pr-2"
        >
          <span v-if="isReturned"> Odwołanie:</span>
          <div :class="{ return: isReturned }">
            <span v-if="count > 1">{{ count }}x</span>
            {{ listing.name }}
          </div>
        </div>
        <div class="d-md-flex align-items-center">
          <div class="bill-payer-name">
            {{ payer?.payerName }}
          </div>
        </div>
      </div>
      <div
        v-if="status !== 'ReserveQueue'"
        class="align-self-center pr-2"
      >
        <div class="money-font text-right text-nowrap">
          {{ formatCurrency(update ? update.totalPrice : price, listing.currency) }}
        </div>
        <template v-if="update && update.totalPrice !== price">
          <div

            class="money-font text-right text-nowrap text-secondary original-price"
          >
            {{ formatCurrency(price, listing.currency) }}
          </div>
          <div class="discount-name">
            {{ update.discountName }}
          </div>
        </template>
      </div>
      <div
        v-else-if="!result"
        class="text-right pr-2"
      >
        <div
          class="badge badge-warning"
        >
          Lista rezerwowa
        </div>
        <div class="small">
          Pozycja: {{ reserveQueuePosition + 1 }}
        </div>
      </div>
      <div
        v-if="!result"
        class="basket-icon d-flex align-items-center justify-content-center"
        @click="remove"
      >
        <i class="far fa-trash" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    payerId: String,
    listing: Object,
    catalog: Object,
    price: Number,
    payer: Object,
    result: String,
    position: Number,
    isReturned: Boolean,
    day: String,
    basketUpdates: Array,
    count: Number,
  },
  computed: {
    ...mapGetters([
      'formatCurrency',
      'catalogIcon',
    ]),
    reserveQueuePosition() {
      return this.position !== undefined ? this.position : this.update?.position;
    },
    status() {
      if (this.result) return this.result;
      return this.update?.status;
    },
    update() {
      return this.basketUpdates?.find((x) => x.offerId === this.listing.id && x.payerId === this.payerId);
    },
  },
  methods: {
    remove() {
      this.$store.commit('removeFromBasket', {
        payerId: this.payerId,
        offerId: this.listing.id,
        day: this.day || '2000-01-01',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bill {
  box-shadow: 0 2px 4px #eee, -1px 2px 4px #eee;
  margin-bottom: 10px;
  padding: 10px;
  font-size: 14px;
  background-color: white;

  &.selected {
    border-left: 2px solid $blue;
  }

  &.deselected {
    border-left: 2px solid #aaa;
    opacity: 0.6;
  }
}

.original-price {
  text-decoration: line-through;
  font-size: 12px;
}

.discount-name {
  color: $blue;
  text-align: right;
  font-size: 10px;
}

.bill-payee-name {
  font-size: 12px;
  color: $blue;
  line-height: 1;
}

.product-set-icon {
  background-color: #eee;
  border-radius: 10px;
  font-size: 20px;
  width: 50px;
  min-width: 50px;
  height: 50px;
  line-height: 50px;
  margin-right: 15px;
  margin-left: 10px;
  text-align: center;
}

.bill-payer-name {
  color: #666;
  font-size: 12px;
}

.bill-due-date {
  font-size: 12px;
  font-weight: 500;

  .return {
    text-decoration: line-through;
  }

  &.overdue {
    color: $red;
  }
}

.info-divider {
  padding-left: 10px;
  padding-right: 10px;
  color: #ccc;
}

.basket-icon {
  background-color: #eee;
  padding: 5px 10px;
  margin-top: -10px;
  margin-bottom: -10px;
  margin-right: -10px;
  text-align: center;
  font-size: 20px;
  width: 45px;
  text-align: center;
  cursor: pointer;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  &:hover {
    background-color: #bbb;
  }

  &.selected {
    background-color: $blue;
    color: white;

    &:hover {
      background-color: darken($blue, 10);
    }
  }
}
</style>
